ScoreTrekBattle.View = (function() {
    var _this, VIEWS, REDIRECTS, STATUS, TIMER, CONFIG;

    VIEWS = {};
    REDIRECTS = {};

    CONFIG = {
        STORAGE_KEY: 'viewHistoryDepth',
        STACK_KEY: 'View.Stack',
        STACK_LIMIT: 100
    };

    STATUS = {
        initalized: false,
        defaultViewId: '',
        currentViewId: '',
        updatingViewId: '',
        navigationId: 0,
        stack: [],
        scrollbarWidth: 0,
        LOADING: {
            FOREGROUND: {},
            BACKGROUND: {}
        }
    };

    TIMER = {};

    function unloadCurrentView() {
        return new Promise(function(resolve) {
            if (VIEWS.hasOwnProperty(STATUS.currentViewId)) {
                ScoreTrekBattle.Event.callFunction.call(STATUS.currentViewId, VIEWS[STATUS.currentViewId].callbacks.onUnload).then(() => {
                }).catch(error => {
                    console.warn(`View unload failed: ${STATUS.currentViewId}`);
                    console.error(error);
                }).finally(() => {
                    ScoreTrekBattle.$body.removeClass('hasSideMenu sideMenu-open');
                    VIEWS[STATUS.currentViewId].$view = null;
                    STATUS.currentViewId = '';
                    updateMenu(STATUS.currentViewId);
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    function prepareInlineView(viewId, viewArgs) {
        return new Promise(function(resolve) {
            if (!VIEWS[viewId].callbacks.onInline) {
                resolve();
                return;
            }

            viewArgs.unshift(VIEWS[viewId].callbacks.onInline);
            ScoreTrekBattle.Event.callFunction.apply(viewId, viewArgs).then(viewHandler => {
                viewArgs.shift();
                resolve(viewHandler);
            });
        });
    }

    function unloadInlineView(viewId) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Event.callFunction.call(viewId, VIEWS[viewId].callbacks.onUnload).then(() => {
                resolve();
            });
        });
    }

    function renderView(viewId, viewArgs) {
        return new Promise(function(resolve) {
            Api.toApp('location', {href: location.href});

            viewArgs.unshift(VIEWS[viewId].callbacks.onRender);
            ScoreTrekBattle.Event.callFunction.apply(viewId, viewArgs).then($view => {
                viewArgs.shift();
                viewArgs.unshift(VIEWS[viewId].callbacks.onLoad);
                ScoreTrekBattle.Event.callFunction.apply(viewId, viewArgs).then(() => {
                    viewArgs.shift();
                    resolve($view);
                }).catch(error => {
                    viewArgs.shift();
                    console.warn(`View load failed: ${viewId}`);
                    console.error(error);
                    resolve(null);
                });
            }).catch(error => {
                viewArgs.shift();
                console.warn(`View render failed: ${viewId}`);
                console.error(error);
                resolve(null);
            });
        });
    }

    function replaceView(viewId, $view) {
        if (!viewId || (STATUS.currentViewId !== viewId)) {
            return;
        }

        VIEWS[viewId].$view = $view;
        ScoreTrekBattle.$main.empty();
        ScoreTrekBattle.$htmlBody.scrollTop(0);
        ScoreTrekBattle.$main.append($view);
    }

    function updateCurrentView(viewArgs) {
        return new Promise(function(resolve) {
            var viewId;

            viewId = STATUS.currentViewId;
            STATUS.updatingViewId = viewId;

            viewArgs.unshift(VIEWS[viewId].callbacks.onUpdate);
            ScoreTrekBattle.Event.callFunction.apply(viewId, viewArgs).then(() => {
                viewArgs.shift();
                STATUS.updatingViewId = '';
                resolve(true);
            }).catch(error => {
                viewArgs.shift();
                STATUS.updatingViewId = '';
                console.warn(`View update failed: ${viewId}`);
                console.error(error);
                resolve(false);
            });
        });
    }

    function updateMenu(highlightViewId) {
        $('#menu [data-view-id]').removeClass('current').filter(`[data-view-id="${highlightViewId || ''}"]`).addClass('current');
        $('#menu .menu > li').removeClass('hasCurrent').has('.current').addClass('hasCurrent');

    }

    function getViewId(viewPath) {
        return searchViewId(viewPath, VIEWS);
    }

    function getRedirect(viewPath) {
        var viewId;
        viewId = searchViewId(viewPath, REDIRECTS);
        if (!viewId) {
            return null;
        }
        return REDIRECTS[viewId];
    }

    function searchViewId(viewPath, reference) {
        var viewPathParts, viewId;
        viewPathParts = viewPath.split('/');
        while (viewPathParts.length > 0) {
            viewId = viewPathParts.join('/');
            if (reference.hasOwnProperty(viewId)) {
                return viewId;
            }
            viewPathParts.pop();
        }
        return false;
    }

    function getCurrentPath() {
        return (location.pathname || '/') + (location.search || '');
    }

    function storeStack() {
        chmStorage.setSession(CONFIG.STACK_KEY, STATUS.stack);
    }

    function restoreStack() {
        var stack;

        stack = chmStorage.getSession(CONFIG.STACK_KEY);

        STATUS.stack = Array.isArray(stack) ? stack : [];
        stackLimit();
    }

    function stackLimit() {
        if (STATUS.stack.length > CONFIG.STACK_LIMIT) {
            STATUS.stack = STATUS.stack.slice(-CONFIG.STACK_LIMIT);
        }
    }

    function stackPush(viewPath) {
        STATUS.stack.push(viewPath);
        stackLimit();
        storeStack();
    }

    function stackReplace(viewPath) {
        if (STATUS.stack.length === 0) {
            STATUS.stack.push(viewPath);
        } else {
            STATUS.stack[STATUS.stack.length - 1] = viewPath;
        }

        storeStack();
    }

    function stackSync(viewPath) {
        var index;

        index = STATUS.stack.lastIndexOf(viewPath);

        if (index === -1) {
            stackPush(viewPath);
            return;
        }

        STATUS.stack.length = (index + 1);
        storeStack();
    }

    function stackPop() {
        STATUS.stack.pop();
        storeStack();

        return STATUS.stack[STATUS.stack.length - 1];
    }

    function getHistoryDepth() {
        return (history.state && (typeof history.state.depth === 'number')) ? history.state.depth : null;
    }

    function readHistoryHandover() {
        var handover;

        handover = sessionStorage.getItem(CONFIG.STORAGE_KEY);
        sessionStorage.removeItem(CONFIG.STORAGE_KEY);

        if (!handover) {
            return null;
        }

        try {
            handover = JSON.parse(handover);
        } catch (error) {
            return null;
        }

        return (handover && (typeof handover.depth === 'number') && handover.href) ? handover : null;
    }

    function initHistory(entryHref) {
        var depth, handover;

        restoreStack();

        if (getHistoryDepth() !== null) {
            return;
        }

        handover = readHistoryHandover();
        depth = (handover && (handover.href === entryHref) && (history.length > 1)) ? (handover.depth + 1) : 0;

        history.replaceState({depth: depth}, '', location.href);
    }

    function pushHistoryEntry(viewPath) {
        history.pushState({depth: (getHistoryDepth() || 0) + 1}, '', viewPath);
        stackPush(viewPath);
    }

    function replaceHistoryEntry(viewPath) {
        history.replaceState({depth: getHistoryDepth() || 0}, '', viewPath);
        stackReplace(viewPath);
    }

    function navigateDocument(url) {
        sessionStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify({
            depth: getHistoryDepth() || 0,
            href: url
        }));

        Api.toApp('reload');

        location.href = url;
    }

    function onLocationChange() {
        var path;
        path = location.pathname;
        if (!path || path === '/') {
            _this.goto(`/${STATUS.defaultViewId}`, false, true);
            return;
        }
        _this.goto(path + (location.search || ''), false, false, true);
    }

    function navigateHistory(action) {
        if (action === 'forward') {
            history.forward();
        } else if (action === 'back') {
            _this.goBack();
        }
    }

    function getView(viewPath) {
        var viewId, viewArgs, redirect;

        viewPath = String(viewPath);

        if (viewPath.substr(0, 1) !== '/') {
            viewPath = `/${viewPath}`;
        }

        viewId = getViewId(viewPath);
        if (!viewId) {
            redirect = getRedirect(viewPath);
            if (redirect) {
                viewPath = `${redirect.redirectViewId}/${viewPath.substr(redirect.viewId.length+1)}`;
                viewId = getViewId(viewPath);
            }
        }

        if (!viewId) {
            console.warn(`Requested view is not registered: ${viewPath}`);
            viewPath = `/${STATUS.defaultViewId}`;
            viewId = getViewId(viewPath);
        }

        if (ScoreTrekBattle.Event.callFunction(VIEWS[viewId].callbacks.onCheckAccess) === false) {
            chmDialog.error('error/noBattleManager');
            viewPath = `/${STATUS.defaultViewId}`;
            viewId = getViewId(viewPath);
        }

        viewArgs = viewPath.substr(viewId.length+1);
        viewArgs = (viewArgs !== '') ? viewArgs.split('/') : [];

        return {
            viewId: viewId,
            viewPath: viewPath,
            viewArgs: viewArgs
        };
    }

    function toggleLoading(mode, id, isLoading) {
            let isBackground;

            isBackground = (mode === 'BACKGROUND');

            if (isLoading) {
                STATUS.LOADING[mode][id] = true;
            } else {
                delete STATUS.LOADING[mode][id];
            }

            isLoading = (Object.keys(STATUS.LOADING[mode]).length > 0);

            clearTimeout(TIMER[`loading_${mode.toLowerCase()}`]);

            TIMER[`loading_${isBackground ? 'background' : 'foreground'}`] = setTimeout(function () {
                ScoreTrekBattle.$body.toggleClass(isBackground ? 'loadingBackground' : 'loading', (isLoading !== false));
            }, isLoading ? 0 : (isBackground ? 400 : 200));

            return isLoading;
    }

    _this = {
        init: function(defaultViewId) {
            let entryHref;

            if (STATUS.initalized) {
                return;
            }

            STATUS.initalized = true;
            STATUS.defaultViewId = defaultViewId;
            entryHref = location.href;

            if (location.hash.indexOf('#/') === 0) {
                history.replaceState(history.state, '', location.hash.substr(1) + (location.search || ''));
            }

            initHistory(entryHref);

            window.addEventListener('popstate', function() {
                if (chmDialog._consumeSuppressedPopState()) {
                    return;
                }
                if (chmDialog.isOpen()) {
                    chmDialog.closeTopFromBack();
                    return;
                }
                if (history.state && history.state.chmDialog) {
                    history.back();
                    return;
                }
                onLocationChange();
            });
            onLocationChange();
        },
		register: function(viewId, onViewRender, onViewLoad, onViewUpdate, onViewUnload, onCheckAccess, onInline) {
            VIEWS[viewId] = {
                $view: null,
                callbacks: {
                    onRender: onViewRender,
                    onLoad: onViewLoad,
                    onUpdate: onViewUpdate,
                    onUnload: onViewUnload,
                    onCheckAccess: onCheckAccess,
                    onInline: onInline 
                }
            };
		},
		registerRedirect: function(viewId, redirectViewId) {
            REDIRECTS[viewId] = {
                viewId: String(viewId),
                redirectViewId: String(redirectViewId)
            };
		},
        goBack: function() {
            let defaultView;

            if (chmDialog.isOpen()) {
                chmDialog.closeTopFromBack();
                return;
            }

            if (STATUS.stack.length > 1) {
                _this.goto(stackPop(), false, true);
                return;
            }

            defaultView = `/${STATUS.defaultViewId}`;

            if (STATUS.currentViewId !== defaultView) {
                _this.goto(defaultView, false, true);
                return;
            }

            Api.toApp('navigate', {action: 'back'});
        },
        goto: function(viewPath, forceRender, replace, fromPopState) {
            return new Promise(resolve => {
                let view, currentPath, navigationId;

                view = getView(viewPath);

                if (view.viewPath !== viewPath) {
                    _this.goto(view.viewPath, forceRender, true).then(resolve);
                    return;
                }

                chmDialog.closeAll();

                currentPath = getCurrentPath();

                if (fromPopState) {
                    stackSync(view.viewPath);
                    if (view.viewPath !== currentPath) {
                        replaceHistoryEntry(view.viewPath);
                    }
                } else if (replace) {
                    replaceHistoryEntry(view.viewPath);
                } else if (view.viewPath !== currentPath) {
                    pushHistoryEntry(view.viewPath);
                } else {
                    stackReplace(view.viewPath);
                }

                if (!forceRender && (STATUS.currentViewId === view.viewId)) {
                    updateCurrentView(view.viewArgs).then(resolve);
                    return;
                }

                navigationId = ++STATUS.navigationId;

                unloadCurrentView().then(() => {
                    if (navigationId !== STATUS.navigationId) {
                        resolve(false);
                        return;
                    }

                    STATUS.currentViewId = view.viewId;
                    updateMenu(STATUS.currentViewId);

                    renderView(view.viewId, view.viewArgs).then($view => {
                        if (navigationId !== STATUS.navigationId) {
                            resolve(false);
                            return;
                        }

                        replaceView(view.viewId, $view);
                        resolve($view !== null);
                    });
                });
            });
        },
        openInline: function(viewPath, title) {
            return new Promise(resolve => {
                let view;

                view = getView(viewPath);

                prepareInlineView(view.viewId, view.viewArgs).then(viewHandler => {
                    if (!viewHandler) {
                        viewHandler = {};
                    }
                    renderView(view.viewId, view.viewArgs).then($view => {
                        chmDialog({
                            content: $view,
                            isOverlay: true,
                            isPersistant: true,
                            buttons: false,
                            title: title,
                            onShow: function() {
                                ScoreTrekBattle.Event.callFunction(viewHandler.onShow, this);
                                resolve($view !== null);
                            },
                            afterClose: function() {
                                unloadInlineView(view.viewId);
                            }
                        });
                    });
                });
            });
        },
        loadingBackground: function (id, isLoading) {
            return toggleLoading('BACKGROUND', id, isLoading);
        },
        loading: function (id, isLoading) {
            return toggleLoading('FOREGROUND', id, isLoading);
        },
        isLoading: function () {
            return ScoreTrekBattle.$body.hasClass('loading');
        },
        navigateDocument: function (url) {
            navigateDocument(url);
        },
        isLoadingBackground: function () {
            return ScoreTrekBattle.$body.hasClass('loadingBackground');
        },
        debugLoading: function () {
            alert(`Loading (background):\n${Object.keys(STATUS.LOADING.BACKGROUND).join('\n')}\n\nLoading (foreground):\n${Object.keys(STATUS.LOADING.FOREGROUND).join('\n')}`);
        },
        // Rewrites the address bar for the view that is already open, without
        // navigating or re-rendering. Used by views whose state belongs in the
        // URL so it can be shared — the league matchday filters, for one.
        setPath: function(viewPath) {
            if (!viewPath || (viewPath === getCurrentPath())) {
                return;
            }

            replaceHistoryEntry(viewPath);
        },
        updateMenu: function(highlighViewId) {
            updateMenu(highlighViewId);
        },
        refresh: function() {
            updateCurrentView(Array.prototype.slice.call(arguments));
        },
        reload: function() {
            // TODO check for unsaved changes

            ScoreTrekBattle.View.loading('View.reload', true);

            Api.request('ping').then(() => {
                Api.toApp('reload');

                setTimeout(() => {
                    location.reload();
                }, 100);
            }).catch(() => {
                ScoreTrekBattle.View.loading('View.reload', false);
                chmDialog.error('error/noConnectionToServer');
            })
        },
        replace: function($view) {
            replaceView(STATUS.updatingViewId, $view);
        },
        getViewportInsets: function() {
            var insets, breakpoint;

            breakpoint = {
                app: document.querySelector('body').dataset.mode === 'app',
                smallMax: matchMedia('(max-width: 920px)').matches
            };

            insets = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            };

            if (breakpoint.app) {
                if (breakpoint.smallMax) {
                    insets.top = document.querySelector('nav.main').offsetHeight;
                }
            } else {
                insets.top = document.querySelector('header').offsetHeight;

                if (breakpoint.smallMax) {
                    insets.bottom = (window.innerHeight - document.querySelector('nav.main').offsetTop);
                }
            }

            return insets;
        },
        getRootMargin: function() {
            var insets;

            insets = _this.getViewportInsets();

            return `-${insets.top + 32}px -${insets.right}px -${insets.bottom + 32}px -${insets.left}px`;
        },
        confirmDiscardChanges: function() {
            return chmDialog.confirm(__i18n('dialog/confirm/discardChanges/text'), {
                title: __i18n('dialog/confirm/discardChanges/title'),
                buttonYes: __i18n('button/discard'),
                buttonNo: __i18n('button/keep')
            });
        }
    };

    ScoreTrekBattle.Event.on('action.view.goto', function(event, viewPath) {
        _this.goto(viewPath);
    });

    ScoreTrekBattle.Event.on('app.to.battle.restart', function(eventData) {
        let defaultView;

        defaultView = `/${STATUS.defaultViewId}`;

        if (STATUS.currentViewId !== defaultView) {
            _this.goto(defaultView);
        }

        Api.toApp('loaded');
    });

    ScoreTrekBattle.Event.on('app.to.battle.ping', function() {
        Api.toApp('pong');
    });

    ScoreTrekBattle.Event.on('app.to.battle.navigate', function(eventData) {
        if (eventData && eventData.action) {
            navigateHistory(eventData.action);
        }
    });

    ScoreTrekBattle.Event.on('app.to.battle.gotoUrl', function(eventData) {
        if (eventData && eventData.url) {
            if (location.href === eventData.url) {
                ScoreTrekBattle.View.reload();
            } else {
                navigateDocument(eventData.url);
            }
        }
    });

    ScoreTrekBattle.Event.on('action.dynamicButtons.toggle', function(event) {
        var $dynamicButtons, isVisible;
        $dynamicButtons = $(this).closest('.dynamicButtons');
        isVisible = $dynamicButtons.hasClass('isVisible');
        $('.dynamicButtons').removeClass('isVisible');
        $dynamicButtons.toggleClass('isVisible', !isVisible);
    });

    ScoreTrekBattle.Event.on('action.scroll.reset', function() {
        document.querySelector('body').dataset.scrolled = 'no';
    });

    ScoreTrekBattle.Event.on('action.gotoTop', function() {
        AnimationHandler.scrollToTop();
    });

    ScoreTrekBattle.Event.on('action.submenu.toggle', function(event) {
        var $item, hasSubmenu;

        event.stopPropagation();
        event.preventDefault();

        $item = $(this).closest('li');
        hasSubmenu = $item.hasClass('subMenu-visible');

        ScoreTrekBattle.Event.trigger('root.click');

        $item.toggleClass('subMenu-visible', !hasSubmenu);
    });

    $(document).on('pulledToRefresh', () => {
        // TODO check for unsaved changes
        ScrollHandler.stop();
        ScoreTrekBattle.View.reload();
    });

    $(document).on('click', 'a.openInline', function(event) {
        let link, base, href, viewPath;

        link = this;
        base = new URL(location.href);

        try {
            href = new URL(link.href, base);
        } catch (e) {
            return;
        }

        if (href.origin !== base.origin) {
            return;
        }

        event.preventDefault();

        if (href.hash.indexOf('#/') === 0) {
            viewPath = href.hash.substr(1);
        } else {
            viewPath = href.pathname + (href.search || '');
        }

        _this.openInline(viewPath, link.dataset.title);
    });

    $(document).on('click', 'a', function(event) {
        var link, base, href, viewPath, currentPath;

        link = this;

        if ($(link).hasClass('openInline')) {
            return;
        }
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }
        if (event.button && event.button !== 0) {
            return;
        }
        if (link.target && link.target !== '' && link.target !== '_self') {
            return;
        }
        if (!link.href) {
            return;
        }

        base = new URL(location.href);

        try {
            href = new URL(link.href, base);
        } catch (e) {
            return;
        }

        if (href.protocol !== 'http:' && href.protocol !== 'https:') {
            return;
        }
        if (href.origin !== base.origin) {
            return;
        }

        event.preventDefault();

        viewPath = href.pathname + (href.search || '');
        currentPath = getCurrentPath();

        if (viewPath === currentPath) {
            _this.refresh();
            return;
        }

        _this.goto(viewPath);
    });

    function updateScrollbarWidth() {
        var scrollbarWidth;
        scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

        if (STATUS.scrollbarWidth === scrollbarWidth) {
            return;
        }
    
        STATUS.scrollbarWidth = scrollbarWidth;

        if (scrollbarWidth === 0) {
            document.querySelector('html').style.removeProperty('--scrollbar-width');
            return;
        }

        document.querySelector('html').style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    }

    setInterval(() => {
        updateScrollbarWidth();
    }, 500);

    window.__goBack = _this.goBack;

    return _this;
})();
